import api from "./axios";

export const chatImage = async ({ id, message, file }) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("message", message);
  formData.append("file", file);

  const response = await api.post("chat/send-message/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const getChatDetail = async ({ id, timezone }) => {
  const res = await api.get("chat/chat-detail/", {
    params: { id, timezone },
  });

  return {
    success: res?.data?.success,
    chat: res?.data?.success ? res.data?.data?.chat_data : null,
  };
};
